<div class="container">
  <div class='error' *ngIf="!isInIframe">
    <img style="width: 40%;" src="../../../assets/images/logo.png" alt="" /><br/>
  </div>
      <h2 class='desc'>You are not authorised to access this page.  <a style="padding-left: 4px;" routerLink="/support">Contact Us</a>.</h2>
</div>

 